let marriageStatusTypes = [
  { value: "MARRIED", label: "Mariée" },
  { value: "SINGLE", label: "Célibataire" },
];

export default marriageStatusTypes;
